/* Client-side conversion events for the Cultiv marketing site.
   Tracks the Meta Pixel directly and also pushes a dataLayer event for GTM to
   forward to Google Ads; the same event_id travels in the form POST so the
   server-side Meta CAPI event deduplicates against the browser one. Each half
   is inert on its own — an unloaded fbq is undefined, and pushing to dataLayer
   without a GTM container is a harmless array append. */

export type ConversionName = 'demo_booking' | 'product_tour';

/* Meta's standard event names, matching what the routes send server-side
   through lib/meta-capi.ts — the pair must agree or dedup fails. */
const META_EVENT: Record<ConversionName, 'Lead' | 'Schedule'> = {
  demo_booking: 'Schedule',
  product_tour: 'Lead',
};

export function newEventId(): string {
  try {
    return crypto.randomUUID();
  } catch {
    return `ev-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  }
}

/** `user_data.email` is raw here — GTM's user-provided-data variable hashes it
 *  before anything leaves the page. It stays inside dataLayer otherwise. */
export function pushConversionEvent(
  name: ConversionName,
  eventId: string,
  userData?: { email?: string }
): void {
  const w = window as typeof window & {
    dataLayer?: unknown[];
    fbq?: (...args: unknown[]) => void;
  };
  (w.dataLayer = w.dataLayer || []).push({
    event: 'cultiv_conversion',
    conversion: name,
    event_id: eventId,
    user_data: userData,
  });
  /* Same eventID as the server-side CAPI call, so Meta counts the pair once.
     Safe before the pixel script loads — fbq's stub queues the call. */
  w.fbq?.('track', META_EVENT[name], {}, { eventID: eventId });
}
